import React, { useEffect, useState } from "react";
import {
    AdvanceTablesWidget2,
    AdvanceTablesWidget3,
    AdvanceTablesWidget4,
} from "../widgets";
import * as crud from "../../../app/pages/Campaign/operations"

import { useSelector } from "react-redux";
export function Demo1Dashboard() {
    const { user } = useSelector(state => state.auth);
    const current = user.uid ? user : user.payload

    const [campaign, setCampaigns] = useState({})
    const [queryng, setQuery] = useState(true)
    const [posv, setPosV] = useState(0)

    useEffect(() => {
        const fetchData = async () => {
            const [
                campaign_query
            ] = await Promise.all([
                crud.getParents()
            ])
            const campaign = campaign_query.data.payload
            const company_campaings = campaign.filter(campaign => campaign.client === current.company_id)
            console.log(company_campaings)
            const [campaing] = company_campaings
            setCampaigns(campaing ?? {})
            if (campaing) {
                console.log(campaing.uid)
                const report_query = await crud.getReport(campaing.uid)
                const report = report_query.data.payload

                const pos = [...new Set(report.map(row => row.pos))]
                const pos_visited = pos.length
                setPosV(pos_visited)
            }
            setQuery(false)
        }
        fetchData()
    }, [current.company_id])
    return (<>
        <div className="row welcome">

            {/* <div className="col-lg-6 col-xxl-4 ">
                <MixedWidget1 className="card-stretch gutter-b " />
            </div> */}
            <div className="col-lg-6 col-xxl-8">
                <AdvanceTablesWidget2 className="card-stretch gutter-b" campaign={campaign} posv={posv} queryng={queryng} />
            </div>
            <div className="col-lg-6 col-xxl-4">
                <AdvanceTablesWidget3 className="card-stretch gutter-b" campaign={campaign} posv={posv} queryng={queryng} />
            </div>
            <div className="col-xxl-12  col-xxl-12">
                <AdvanceTablesWidget4 className="card-stretch gutter-b" />
            </div>
            <div className="col-lg-6 col-xxl-4">
                {/* <ListsWidget3 className="card-stretch gutter-b" /> */}

            </div>
            <div className="col-lg-6 col-xxl-4">
                {/* <ListsWidget9 className="card-stretch gutter-b" /> */}
            </div>




            <div className="col-lg-6 col-xxl-4 order-1 order-xxl-2">
                {/* <ListsWidget1 className="card-stretch gutter-b" /> */}

            </div>
            {/* <div className="col-lg-6 col-xxl-4 order-1 order-xxl-2">
                    <MixedWidget14 className="card-stretch gutter-b" />
                </div> */}


        </div>
        <div className="row">
            {/* <div className="col-lg-4">
                    <MixedWidget14 className="card-stretch gutter-b" />
                </div> */}

        </div>
    </>);
}
